import { get } from "lodash";
import htmlToFormattedText from "html-to-formatted-text";

export const modifyDataForPost = data => {
  return {
    // actionItemCOS: get(data, "actionItemCOS").filter(value => {
    //   return value.description && value.assignTo;
    // }),
    decisionStatus: get(data, "decisionStatus", null),
    description: htmlToFormattedText(get(data, "description", null)),
    id: get(data, "id", null),
    issueId: get(data, "issueId", null),
    issueStatus: get(data, "issueStatus") && +get(data, "issueStatus"),
    meetingId: get(data, "meetingId", null),
    taskCompletionDate: get(data, "taskCompletionDate", null) || null,
    recipientGroupId: +get(data, "assigneeGroupId"),
    files: get(data, "files", []).map(val => val.id),
    districtDept: get(data, "districtDept"),
    files: get(data, "files", []).map(val => val.id)
  };
};

export const modifyDataForIssueListPost = data => {
  return {
    decisionStatus: get(data, "decisionStatus", null),
    description: htmlToFormattedText(get(data, "description", null)),
    id: get(data, "id", null),
    issueId: get(data, "issueId", null),
    issueStatus: +get(data, "issueStatus", null),
    statusId: +get(data, "issueStatus", null),
    taskCompletionDate: get(data, "taskCompletionDate", null) || null,
    meetingId: get(data, "meetingId", null) || null,
    recipientGroupId: +get(data, "assigneeGroupId"),
    files: get(data, "files", []).map(val => val.id),
    districtDept: get(data, "districtDept"),
    task1: get(data, "task1", null),
    task1CompletionDate: get(data, "task1CompletionDate", null),
    task2: get(data, "task2", null),
    task2CompletionDate: get(data, "task2CompletionDate", null),
    secondaryStateId: get(data, "secondaryStateId", null),
    secondaryStateDepartmentId: get(data, "secondaryStateDepartmentId", null),
    secondaryMinistryId: get(data, "secondaryMinistryId", null),
    secondaryMinistryDepartmentId: get(
      data,
      "secondaryMinistryDepartmentId",
      null
    ),
    secondaryRecipientGroupId: get(data, "secondaryRecipientGroupId", null),
    secondaryRecipientGroupName: get(data, "secondaryRecipientGroupName", null),
    secondaryRecipientGroup: get(data, "secondaryRecipientGroupId", null)
  };
};

export const modifyDataForProjectDecisionPost = data => {
  let projectDecisionMeetingType = get(
    data,
    "projectMeetingType",
    null
  ).replace(/ /g, "_");
  return {
    decisionName: get(data, "agendaName", null),
    projectMOM: htmlToFormattedText(get(data, "projectMOM", null)),
    id: get(data, "id", null),
    projectId: get(data, "projectId", null),
    meetingDate: get(data, "meetingDate", null) || null,
    meetingTimeFrom: get(data, "meetingTimeFrom", null) || null,
    meetingTimeTo: get(data, "meetingTimeTo", null) || null,
    meetingId: get(data, "meetingId", null) || null,
    fileAttachment: get(data, "files", []).map(val => val.id),
    venue: parseInt(get(data, "venue", null)),
    meetingChairedBy: htmlToFormattedText(get(data, "meetingChairedBy", null)),
    projectMeetingType: projectDecisionMeetingType,
    meetingMode: htmlToFormattedText(get(data, "meetingMode", null))
  };
};
